import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Routes, Route, Outlet } from "react-router-dom";
import Breadcrumb from "../breadcrumb/Breadcrumb";

function StudentDashboard({ menu }) {
  return (
    <div className="grid grid-cols-5 grid-rows-1 h-full">
      <div>
        <Sidebar menu={menu} />
      </div>
      <div className=" h-full col-span-4 py-16 px-16">
        <main>
          <div>
            <Breadcrumb className="mb-[5rem] pr-[1.7rem]" />
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

export default StudentDashboard;
